import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import { Row, Col, Tooltip, } from 'reactstrap';
import React, { useEffect, useState } from 'react'
import { defaultPageSize, EMPTY_DATA } from '../../../../config/constants';
import { hyphenFormatter } from '../../../masters/masterUtil';
import Button from '../../../layout/Button';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import ReactExport from "react-export-excel";
import { getCostDeviationReport } from '../../actions/ReportListing';
import NoContentFound from '../../../common/NoContentFound';
import { PaginationWrapper } from '../../../common/commonPagination';
import { COSTDEVIATION_CONVERSION_COST_LISTING_DOWNLOAD_EXCEL, COSTDEVIATION_LISTING_DOWNLOAD_EXCEL } from '../../../../config/masterData';
const gridOptions = {};
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const CostDeviationListing = ({ formData, viewCostVariance, appliedOn }) => {
    const [gridDataList, setGridDataList] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const { costDeviationReportList } = useSelector(state => state.report);
    const dispatch = useDispatch();
    const [state, setState] = useState({
        isLoader: false,
        noData: false,
        totalRecordCount: 0,
        dataCount: 0
    });
    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
    };

    useEffect(() => {
        setState((prevState) => ({ ...prevState, isLoader: true }));
        const dataToProcess = formData || costDeviationReportList || [];
        let grouped_data = _.groupBy(dataToProcess, 'PartNumber')                                    // GROUPING OF THE ROWS FOR SEPERATE PARTS
        let data = []
        for (let x in grouped_data) {
            let seprateData = grouped_data[x]
            seprateData[Math.round(seprateData.length / 2) - 1].PartNo = x;                                   // SHOWING PART NUMBER IN MIDDLE
            seprateData[seprateData.length - 1].LastRow = true;                                               // ADDING LASTROW KEY FOR SHOWING SEPERATE BORDER
            seprateData[Math.round(seprateData.length / 2) - 1].RowMargin = seprateData.length >= 2 && seprateData.length % 2 === 0 && 'margin-top';    // ADDING ROWMARGIN KEY IN THE GRID FOR EVEN ROW AND AS WELL AS PARTS HAVE TWO OR MORE COSTING
            data.push(seprateData)
        }
        // setGridDataList(data)
        let newArray = []
        data.map((item) => {
            newArray = [...newArray, ...item]
        })
        setGridDataList(newArray)
        setTimeout(() => {
            setState((prevState) => ({ ...prevState, isLoader: false }));
        }, 500);
        setState((prevState) => ({ ...prevState, totalRecordCount: dataToProcess?.length }));
    }, [formData, costDeviationReportList]);
    const onGridReady = (params) => {
        if(appliedOn?.value === 4){
            params.api.sizeColumnsToFit();
        }
    }
    const getDataList = (skip, take, floatingFilterData) => {
        dispatch(getCostDeviationReport(skip, take, floatingFilterData))
    }

    const onFloatingFilterChanged = (value) => {

    }
    const onPageSizeChanged = (newPageSize) => {
        gridApi?.paginationSetPageSize(Number(newPageSize));
        setState((prevState) => ({ ...prevState, globalTake: newPageSize }));
    }
    const viewDetails = (cellValue, rowData, isEdit) => {
        viewCostVariance({
            view: true,
            data: {
                TechnologyId: rowData.TechnologyId,
                PartId: rowData.PartId,
            }
        })
    }

    const onBtExport = () => {
        let tempArr = [];
        // tempArr = state.gridApi && state.gridApi?.getSelectedRows();
        
        const dataToExport = formData || costDeviationReportList || [];
        tempArr =
          tempArr && tempArr.length > 0
            ? tempArr
            : dataToExport;
        return (appliedOn.value === 4) ? returnExcelColumn(COSTDEVIATION_CONVERSION_COST_LISTING_DOWNLOAD_EXCEL, tempArr) : returnExcelColumn(COSTDEVIATION_LISTING_DOWNLOAD_EXCEL, tempArr);
      };
    
     const returnExcelColumn = (data = [], TempData) => {
        return (
          <ExcelSheet data={TempData} name="CostDeviationListing">
            {data &&
              data.map((ele, index) => (
                <ExcelColumn
                  key={index}
                  label={ele.label}
                  value={ele.value}
                  style={ele.style}
                />
              ))}
          </ExcelSheet>
        );
      };
    const buttonRenderer = (props) => {
        const cellValue = props?.valueFormatted ? props.valueFormatted : props?.value;
        const rowData = props?.valueFormatted ? props.valueFormatted : props?.data;
        return <Button
            id={`rmDomesticListing_view${props.rowIndex}`}
            className={"mr-1 Tour_List_View"}
            variant="View"
            onClick={() => viewDetails(cellValue, rowData, true)}
            title={"View"}
        />
    }
    const PartNoRenderer = (props) => {
        return <div className='row-span'>{props?.data?.PartNo}</div>
    }
    const frameworkComponents = {
        hyphenFormatter: hyphenFormatter,
        buttonRenderer: buttonRenderer,
        PartNoRenderer: PartNoRenderer,
        customNoRowsOverlay: NoContentFound
    }
    const cellClass = (props) => {
        return `${props?.data?.LastRow ? `border-color` : ''} ${props?.data?.RowMargin} colorWhite`          // ADD SCSS CLASSES FOR ROW MERGING
    }
    return (
        <div className="ag-grid-react ">
            <div className={`ag-grid-wrapper height-width-wrapper ${(gridDataList && gridDataList?.length <= 0) ? "overlay-contain" : ""}`}>
                <Row className="filter-row-large pt-4 blue-before">
                    <Col md="3" lg="3" className="search-user-block mb-3">
                        <div className="d-flex justify-content-end bd-highlight w100">

                        <ExcelFile
                            filename={"Cost Deviation"}
                            fileExtension={".xls"}
                            element={
                                <Button className="mr5 Tour_List_Download" id={"costDeviation_excel_download"} disabled={state?.totalRecordCount === 0} title={`Download ${state.dataCount === 0 ? "All" : "(" + state.dataCount + ")"}`} icon={"download mr-1"} buttonName={`${state.dataCount === 0 ? "All" : "(" + state.dataCount + ")"}`} />
                            }
                            >
                            {state?.totalRecordCount !== 0 ? onBtExport() : null}
                        </ExcelFile>
                        </div>
                    </Col >
                </Row >

                <Row>
                    <Col md="12">
                    <div className={`ag-grid-wrapper ${(gridDataList && gridDataList?.length <= 0) ? "overlay-contain" : ""}`}>
                        <div className="ag-grid-header">
                            <input type="text" className="form-control table-search" id="filter-text-box" placeholder="Search" autoComplete={'off'} onChange={(e) => { }} />
                        </div>
                        <div className={`ag-theme-material p-relative ${state.isLoader && "max-loader-height"}`}>
                            {!state.isLoader && <AgGridReact
                                defaultColDef={defaultColDef}
                                floatingFilter={true}
                                domLayout='autoHeight'
                                // columnDefs={c}
                                rowData={gridDataList}

                                pagination={true}
                                paginationPageSize={defaultPageSize}
                                onGridReady={onGridReady}
                                gridOptions={gridOptions}
                                loadingOverlayComponent={'customLoadingOverlay'}
                                noRowsOverlayComponent={'customNoRowsOverlay'}
                                // noRowsOverlayComponentParams={{ title: EMPTY_DATA, imagClass: 'imagClass' }}
                                noRowsOverlayComponentParams={{ title: 'No Deviations Identified', imagClass: 'imagClass' }}
                                rowSelection={'multiple'}
                                onFilterModified={onFloatingFilterChanged}
                                onSelectionChanged={() => { }}
                                frameworkComponents={frameworkComponents}
                                suppressRowClickSelection={true}
                            >
                                <AgGridColumn field="PartNo" cellClass={cellClass} cellRenderer={'PartNoRenderer'} headerName="Part Number" ></AgGridColumn>
                                <AgGridColumn width={140} field="RevisionNumber" headerName="Revision Number" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                <AgGridColumn width={220} field="VendorCode" headerName="Vendor Code" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                {appliedOn?.value !== 4 ? (
                                    <>
                                        <AgGridColumn width={210} field="RawMaterialGrossWeight" headerName="RM Gross Weight" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={245} field="RawMaterialFinishWeight" headerName="RM Finish Weight" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={150} field="RawMaterialScrapWeight" headerName="RM Scrap Weight" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={150} field="RawMaterialRate" headerName="RM Rate" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={150} field="ScrapRate" headerName="Scrap Rate" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={150} field="NetRawMaterialsCost" headerName="Net Raw Materials Cost" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={150} field="RawMaterialName" headerName="RM Name" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={150} field="RawMaterialCode" headerName="RM Code" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={150} field="RawMaterialGrade" headerName="RM Grade" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                        <AgGridColumn width={150} field="RawMaterialSpecification" headerName="RM Specification" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                    </>) :
                                    <AgGridColumn width={150} field="NetConversionCost" headerName="Net Conversion Cost" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                }
                                <AgGridColumn width={150} field="NetPoPrice" headerName="Net Price " cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                <AgGridColumn width={150} field="BudgetedVolumeQuantity" headerName="Annual Volume" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                <AgGridColumn width={150} field="NetPoPriceWithBudgetedQuantity" headerName="Potential Impact" cellRenderer={'hyphenFormatter'}></AgGridColumn>
                                <AgGridColumn width={150} field="PartNumber" cellClass="ag-grid-action-container" pinned="right" headerName="Action" type="rightAligned" floatingFilter={false} cellRenderer={'buttonRenderer'}></AgGridColumn>
                            </AgGridReact>}
                            {<PaginationWrapper gridApi={state.gridApi} setPage={onPageSizeChanged} globalTake={state.globalTake} />}
                        </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

    )
}

export default CostDeviationListing
